import _ from 'lodash'
/* eslint-disable */
var OwlTingApplePay = function (div_id, apiUrl) {
  this.applepay_session = false;
  this.div_id = div_id;
  this.apiUrl = apiUrl;
  this.usingApp = false;
  this.requestAppApplepay();
}

OwlTingApplePay.prototype = {

  isApplePaySupported: function () {
    return window.ApplePaySession;
  }
  , isCanMakePayment: function () {
    if (this.isApplePaySupported()) {
      return window.ApplePaySession.canMakePayments();
    }
    return false;
  }

  , requestAppApplepay: function () {
    if (typeof window.webkit == 'undefined') return;
    var message = {
      'method': "RequestApplepay",
      'version': "1.0",
      'update_time': "2017-05-16"
    };
    if (typeof window.webkit.messageHandlers.OwlTingAppConnection != 'undefined') {
      window.webkit.messageHandlers.OwlTingAppConnection.postMessage(message);
    }
  }

  , app_ShowApplepayButton: function () {
    this.usingApp = true;
    this.showApplePayUI();
  }
  , app_cancelApplepay: function () {
    this.cancelApplepay();
  }
  , app_receiveToken: function (payment_token_string) {
    var payment_token = JSON.parse(payment_token_string);
    sendPost(payment_token);
  }

  , sendIfTokenValid: function (applepay_token, currency, country, production_name, totalPrice) {

    if (typeof applepay_token == "undefined" || _.isEmpty(applepay_token)) {
      if (this.usingApp) {
        if (typeof window.webkit == 'undefined') return;
        var message = {
          'method': 'ExecuteApplepay',
          'payment_amount': totalPrice
        };
        if (typeof window.webkit.messageHandlers.OwlTingAppConnection != 'undefined') {
          window.webkit.messageHandlers.OwlTingAppConnection.postMessage(message);
        }
        return;
      }

      this.startSession(currency, country, production_name, totalPrice);
      // console.log('startSession')
      return;
    } else {
      return true;
    }
  }

  , apay_performValidation: function (apiUrl, valURL) {
    return new Promise(function (resolve, reject) {
      var xhr = new XMLHttpRequest();
      xhr.onload = function () {
        var data = JSON.parse(this.responseText);
        resolve(data);
      };
      xhr.onerror = reject;
      xhr.open('POST', apiUrl);
      xhr.setRequestHeader("Content-type", "application/x-www-form-urlencoded");
      xhr.send("u=" + encodeURIComponent(valURL));
    });
  }


  , startSession: function (currency, country, production_name, totalPrice) {

    var paymentRequest = {
      currencyCode: currency,
      countryCode: country,
      lineItems: [],
      total: {
        label: production_name,
        amount: totalPrice
      },
      supportedNetworks: ['masterCard', 'visa'],
      merchantCapabilities: ['supports3DS']
    };

    var session = new ApplePaySession(2, paymentRequest);
    var thisObj = this;

    session.onvalidatemerchant = function (event) {
      var promise = thisObj.apay_performValidation(thisObj.apiUrl, event.validationURL);
      promise.then(function (merchantSession) {
        session.completeMerchantValidation(merchantSession);
      });
    }

    session.onpaymentmethodselected = function (event) {
      var newTotal = { type: 'final', label: production_name, amount: totalPrice };
      var newLineItems = [];

      session.completePaymentMethodSelection(newTotal, newLineItems);
    }

    session.onpaymentauthorized = function (event) {
      thisObj.sendApplepay(event.payment.token);
    }

    session.oncancel = function (event) {
      thisObj.cancelApplepay();
    }

    this.applepay_session = session;
    if (session)
      session.begin();

  }
  , completePaymentSession: function (status) {
    if (this.usingApp) {
      return;
    }

    if (this.applepay_session && status == 1) {
      this.applepay_session.completePayment(ApplePaySession.STATUS_SUCCESS);
    } else {
      this.applepay_session.completePayment(ApplePaySession.STATUS_FAILURE);
    }
  }
  , completePaymentSessionSuccess: function () {
    this.completePaymentSession(1);
  }
  , completePaymentSessionFail: function () {
    this.completePaymentSession(0);
  }
  , showApplePayUI: function () {
    if (typeof this.event_ShowApplepay != 'undefined') {
      this.event_ShowApplepay();
    }
  }
  , cancelApplepay: function () {
    if (typeof this.event_CancelApplepay != 'undefined') {
      this.event_CancelApplepay();
    }
  }
  , sendApplepay: function (token) {
    if (typeof this.event_SendApplepay != 'undefined') {
      this.event_SendApplepay(token);
    }
  }
}

export default OwlTingApplePay